<div class="wrapper__headerComponent container my-5">
  <div class="row align-items-center mb-4">
    <h2 class="text-left h3-tipografia-govco mb-0">{{ 'metricas.titulo' | translate}}</h2>
  </div>

  <div class="contenedor-tabla w-100">
    <app-table
      [estiloEncabezado]="'height: auto !important;'"
      [datos]="metricas"
      [columnas]="columnas"
      [paginacion]="false"
      [acciones]="acciones"
      (eventoAccion)="verCorreos($event)"></app-table>
  </div>
</div>
<!-- Modal que lista los correos-->
<div class="modal-container" *ngIf="showModal">
  <button
    id="modalCorreos"
    #modalCorreos
    data-bs-toggle="modal"
    data-bs-target="#modalAlerta1"
    hidden="hidden"
    hidden
    aria-hidden="true"
    tabindex="-1">
    Launch
  </button>
  <div
    class="modal fade"
    id="modalAlerta1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title h5-tipografia-govco">
            {{ 'metricas.correos' | translate }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="container">
            <app-form
              [fields]="campoCorreo"
              [withSubmitButton]="false"
              [withCamposObligatorios]="false"
              (changeAction)="onSubmit($event)"></app-form>
            <div class="d-flex justify-content-end">
              <button
                type="button"
                class="btn btn-govco outline-btn-govco my-2"
                (click)="agregar()"
                [disabled]="formCorreo.invalid"
                aria-label="Agregar correo">
                <i class="fa fa-plus fa-lg me-2"></i>
                {{ 'metricas.agregar' | translate }}
              </button>
            </div>
          </div>
          <div class="container mt-3">
            <ul class="list-group">
              <li
                *ngFor="let correo of correos"
                class="list-group-item d-flex flex-wrap align-items-center justify-content-between">
                <span class="flex-grow-1 text-break">{{ correo.correoElectronico }}</span>
                <button
                  type="button"
                  class="btn btn-actions btn-just-icon p-0 mx-1 btn-sm hvr-shrink govco-svg-red"
                  (click)="eliminar(correo)"
                  aria-label="Eliminar correo">
                  <i class="fa fa-trash fa-lg"></i>
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn-govco fill-btn-govco"
            data-bs-dismiss="modal"
            aria-label="Cerrar">
            {{ 'metricas.cerrar' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
